import React, { useState } from 'react';
import {
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Card,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QRCode from "react-qr-code";
// import QRCode from 'qrcode.react';
import { AdminApi } from "../../api/AdminApi";

const HealthDataSearchSection = () => {
    const [keyword, setKeyword] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [qrCodeVisible, setQrCodeVisible] = useState(false);
    const [qrCodeUrl, setQrCodeUrl] = useState('');

    const handleSearch = async () => {
        console.debug('Searching for keyword:', keyword);
        try {
            const results = await AdminApi.searchHealthData(keyword);
            setSearchResults(results);
        } catch (error) {
            console.error('Error fetching health data:', error);
        }
    };

    const showInNewTab = (url) => {
        const newTab = window.open(url, '_blank', 'noopener,noreferrer');
        if (newTab) {       
            newTab.opener = null; // Prevents the new tab from accessing the original window
        } else {
            console.error('Failed to open new tab. Please allow pop-ups for this site.');
        }
    };

    const showQrCode = (url) => {
        setQrCodeUrl(url);
        setQrCodeVisible(true);
    };

    const closeQrCodeModal = () => {
        setQrCodeVisible(false);
        setQrCodeUrl('');
    };

    return (
        <Card style={{ padding: 16 }}>
            <Stack spacing={2}>
                {/* Part 1: Search Input and Button */}
                <Stack direction="row" spacing={2} alignItems="center">
                    <TextField
                        label="Enter keyword"
                        variant="outlined"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Button variant="contained" color="primary" onClick={handleSearch}>
                        Search
                    </Button>
                </Stack>

                {/* Part 2: Table */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>紀錄時間</TableCell>
                                <TableCell>參加者編號</TableCell>
                                <TableCell>參加者名字</TableCell>
                                <TableCell>參加者Email</TableCell>
                                <TableCell>檢視QRCode</TableCell>
                                <TableCell>檢視報告</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {searchResults.map((record) => (
                                <TableRow key={record.id}>
                                    <TableCell>{record.record_time}</TableCell>
                                    <TableCell>{record.user_id}</TableCell>
                                    <TableCell>{record.display_name}</TableCell>
                                    <TableCell>{record.email}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => showQrCode(record.report_url)}
                                        >
                                            View QR Code
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => showInNewTab(record.report_url)}
                                        >
                                            View Now
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* QR Code Modal */}
                <Dialog open={qrCodeVisible} onClose={closeQrCodeModal}>
                    <DialogTitle>
                        Report QR Code
                        <IconButton
                            aria-label="close"
                            onClick={closeQrCodeModal}
                            style={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ textAlign: 'center' }}>
                            {/* <QRCode value={"12312312"} size={100} /> */}
                            <QRCode value={qrCodeUrl} size={200} />
                        </div>
                    </DialogContent>
                </Dialog>
            </Stack>
        </Card>
    );
};

export default HealthDataSearchSection;